import { CradleIcon } from './CradleIcon';

/**
 * author: Google
 * id 74B57630-EBF9-48DB-886C-36FA79D4350B
 * name cradle
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cradle.svg
 * tags
 * - People / Family 
 * - Home Automation 
 */
export const BassinetIcon = CradleIcon;
export default BassinetIcon